<section class="platform-page">
  <header class="platform-page__header">
    <p class="platform-page__eyebrow">Bug Reports</p>
    <h2>Platform Bug Reports</h2>
    <p>Review issues reported across organizations.</p>
  </header>

  <mat-card class="bugs-card">
    <div class="bugs-toolbar">
      <mat-form-field appearance="outline">
        <mat-label>Search bug reports</mat-label>
        <input matInput type="text" [value]="searchTerm()" (input)="updateSearchTerm($any($event.target).value)" />
        <mat-icon matSuffix aria-hidden="true">search</mat-icon>
      </mat-form-field>
    </div>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Issue</th>
            <th>Status</th>
            <th>Organization</th>
            <th>Reporter</th>
            <th>Page</th>
            <th>Version</th>
            <th>Created</th>
            <th>Assets</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if (bugReportsLoading()) {
            <tr>
              <td colspan="9" class="table-empty">Loading bug reports...</td>
            </tr>
          } @else {
            @for (report of filteredBugReports(); track report.id) {
              <tr>
                <td>
                  <div class="issue-cell">
                    <strong>{{ report.title || 'Untitled bug report' }}</strong>
                    <p>{{ report.description || '-' }}</p>
                  </div>
                </td>
                <td>
                  <span class="status-chip" [class.status-chip--closed]="report.status === 'closed'">
                    {{ report.status || 'open' }}
                  </span>
                </td>
                <td>{{ report.organization_id }}</td>
                <td>{{ report.user_id }}</td>
                <td>
                  @if (report.page_url) {
                    <a [href]="report.page_url" target="_blank" rel="noreferrer">Open page</a>
                  } @else {
                    <span>-</span>
                  }
                </td>
                <td>{{ report.app_version || '-' }}</td>
                <td>{{ formatDate(report.created_at) }}</td>
                <td>
                  @if (report.screenshot_url) {
                    <a [href]="report.screenshot_url" target="_blank" rel="noreferrer">View screenshot</a>
                  }
                  @if ((report.attachments?.length ?? 0) > 0) {
                    <div>
                      @for (attachment of report.attachments ?? []; track attachment.key) {
                        @if (attachment.url) {
                          <div><a [href]="attachment.url" target="_blank" rel="noreferrer">{{ attachment.name || 'Attachment' }}</a></div>
                        }
                      }
                    </div>
                  } @else {
                    @if (!report.screenshot_url) {
                      <span>-</span>
                    }
                  }
                </td>
                <td>
                  @if (report.status !== 'closed') {
                    <button type="button" mat-stroked-button (click)="closeBug(report)">Close</button>
                  } @else {
                    <span>-</span>
                  }
                </td>
              </tr>
            }
            @if (filteredBugReports().length === 0) {
              <tr>
                <td colspan="9" class="table-empty">No bug reports matched your search.</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </mat-card>
</section>
